export default {
    "name": "searchItineraryAddresses",
    "kind": "HoudiniQuery",
    "hash": "c9831bd948b8e1e0cb5fabf7f3e6edd90c9ea728bf4cf50882dc4d0051bf5502",

    "raw": `query searchItineraryAddresses($input: SearchItineraryAddressesInput!) {
  searchItineraryAddresses(input: $input) {
    arrivalLocalizedHierarchies {
      ...LocalizedHierarchyFragment
    }
    departureLocalizedHierarchies {
      ...LocalizedHierarchyFragment
    }
    arrivalCityHierarchy {
      ...HierarchySegmentFragment
    }
    nearbyArrivalCitiesHierarchies {
      ...HierarchySegmentFragment
    }
    departure {
      location {
        lat
        lng
      }
      countryCode
      zipCode
      region
    }
    arrival {
      location {
        lat
        lng
      }
      countryCode
      zipCode
      region
    }
  }
}

fragment LocalizedHierarchyFragment on LocalizedHierarchy {
  hierarchy {
    value
    label
  }
  locale
  __typename
}

fragment HierarchySegmentFragment on HierarchySegment {
  value
  label
  __typename
}`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "searchItineraryAddresses": {
                "type": "SearchItineraryAddressesResult",
                "keyRaw": "searchItineraryAddresses(input: $input)",

                "selection": {
                    "fields": {
                        "arrivalLocalizedHierarchies": {
                            "type": "LocalizedHierarchy",
                            "keyRaw": "arrivalLocalizedHierarchies",

                            "selection": {
                                "fields": {
                                    "hierarchy": {
                                        "type": "HierarchySegment",
                                        "keyRaw": "hierarchy",

                                        "selection": {
                                            "fields": {
                                                "value": {
                                                    "type": "String",
                                                    "keyRaw": "value",
                                                    "visible": true
                                                },

                                                "label": {
                                                    "type": "String",
                                                    "keyRaw": "label",
                                                    "nullable": true,
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "locale": {
                                        "type": "String",
                                        "keyRaw": "locale",
                                        "visible": true
                                    },

                                    "__typename": {
                                        "type": "String",
                                        "keyRaw": "__typename",
                                        "visible": true
                                    }
                                },

                                "fragments": {
                                    "LocalizedHierarchyFragment": {
                                        "arguments": {}
                                    }
                                }
                            },

                            "visible": true
                        },

                        "departureLocalizedHierarchies": {
                            "type": "LocalizedHierarchy",
                            "keyRaw": "departureLocalizedHierarchies",

                            "selection": {
                                "fields": {
                                    "hierarchy": {
                                        "type": "HierarchySegment",
                                        "keyRaw": "hierarchy",

                                        "selection": {
                                            "fields": {
                                                "value": {
                                                    "type": "String",
                                                    "keyRaw": "value",
                                                    "visible": true
                                                },

                                                "label": {
                                                    "type": "String",
                                                    "keyRaw": "label",
                                                    "nullable": true,
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "locale": {
                                        "type": "String",
                                        "keyRaw": "locale",
                                        "visible": true
                                    },

                                    "__typename": {
                                        "type": "String",
                                        "keyRaw": "__typename",
                                        "visible": true
                                    }
                                },

                                "fragments": {
                                    "LocalizedHierarchyFragment": {
                                        "arguments": {}
                                    }
                                }
                            },

                            "visible": true
                        },

                        "arrivalCityHierarchy": {
                            "type": "HierarchySegment",
                            "keyRaw": "arrivalCityHierarchy",

                            "selection": {
                                "fields": {
                                    "value": {
                                        "type": "String",
                                        "keyRaw": "value",
                                        "visible": true
                                    },

                                    "label": {
                                        "type": "String",
                                        "keyRaw": "label",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "__typename": {
                                        "type": "String",
                                        "keyRaw": "__typename",
                                        "visible": true
                                    }
                                },

                                "fragments": {
                                    "HierarchySegmentFragment": {
                                        "arguments": {}
                                    }
                                }
                            },

                            "visible": true
                        },

                        "nearbyArrivalCitiesHierarchies": {
                            "type": "HierarchySegment",
                            "keyRaw": "nearbyArrivalCitiesHierarchies",

                            "selection": {
                                "fields": {
                                    "value": {
                                        "type": "String",
                                        "keyRaw": "value",
                                        "visible": true
                                    },

                                    "label": {
                                        "type": "String",
                                        "keyRaw": "label",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "__typename": {
                                        "type": "String",
                                        "keyRaw": "__typename",
                                        "visible": true
                                    }
                                },

                                "fragments": {
                                    "HierarchySegmentFragment": {
                                        "arguments": {}
                                    }
                                }
                            },

                            "visible": true
                        },

                        "departure": {
                            "type": "ItineraryLocation",
                            "keyRaw": "departure",

                            "selection": {
                                "fields": {
                                    "location": {
                                        "type": "Coordinates",
                                        "keyRaw": "location",

                                        "selection": {
                                            "fields": {
                                                "lat": {
                                                    "type": "Float",
                                                    "keyRaw": "lat",
                                                    "visible": true
                                                },

                                                "lng": {
                                                    "type": "Float",
                                                    "keyRaw": "lng",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "countryCode": {
                                        "type": "String",
                                        "keyRaw": "countryCode",
                                        "visible": true
                                    },

                                    "zipCode": {
                                        "type": "String",
                                        "keyRaw": "zipCode",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "region": {
                                        "type": "String",
                                        "keyRaw": "region",
                                        "nullable": true,
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "arrival": {
                            "type": "ItineraryLocation",
                            "keyRaw": "arrival",

                            "selection": {
                                "fields": {
                                    "location": {
                                        "type": "Coordinates",
                                        "keyRaw": "location",

                                        "selection": {
                                            "fields": {
                                                "lat": {
                                                    "type": "Float",
                                                    "keyRaw": "lat",
                                                    "visible": true
                                                },

                                                "lng": {
                                                    "type": "Float",
                                                    "keyRaw": "lng",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "countryCode": {
                                        "type": "String",
                                        "keyRaw": "countryCode",
                                        "visible": true
                                    },

                                    "zipCode": {
                                        "type": "String",
                                        "keyRaw": "zipCode",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "region": {
                                        "type": "String",
                                        "keyRaw": "region",
                                        "nullable": true,
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "input": "SearchItineraryAddressesInput"
        },

        "types": {
            "CoordinatesInput": {
                "lat": "Float",
                "lng": "Float"
            },

            "AddressQuery": {
                "coordinates": "CoordinatesInput",
                "entityType": "AddressEntityType",
                "query": "String"
            },

            "SearchItineraryAddressesInput": {
                "arrival": "AddressQuery",
                "departure": "AddressQuery"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "CacheOrNetwork",
    "partial": false
};

"HoudiniHash=6c636c5b096169026dc0732386fa41201edd5f074d078aa363ce8326408da726";